import store from "../../store/index";
import apiInfraction from "../axios/apiInfraction";

class InfractorService {
  static async getInfractorByPlate(plate) {
    try {
      const response = await apiInfraction.get(`/infractors/by-plate/${plate}`);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getUserByCuil(cuil) {
    try {
      const cidi = store.state.CidiCookie; // Access state from Vuex store
      const response = await apiInfraction.get(`/infractors/user-by-cuil/${cuil}&${cidi}`);
      if (response.status === 200) {
        //si encuentra o no respondera 200 pero sera succes si es no null la data
        return { success: response.data !== null, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async CreateInfractor(body) {
    try {
      const response = await apiInfraction.post("/infractors/create", body);
      if (response.status === 201) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async CreateUserOnly(body) {
    try {
      const response = await apiInfraction.post("/infractors/create-user-only", body);
      if (response.status === 201) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default InfractorService;
